import React, { useEffect } from "react";
import lottie from 'lottie-web';
import animationDataMobile from "./mobile-signup-animation.json";
import animationDataDesktop from "./desktop-signup-animation.json";
import { isMobileDevice } from "../../../utils/web-helper";

const SignupAnimation = () => {
  useEffect(() => {
    let animationData = isMobileDevice() ? animationDataMobile : animationDataDesktop;

    lottie.loadAnimation({
      container: document.getElementById('signup-animation'),
      renderer: 'svg',
      loop: false,
      autoplay: true,
      animationData: animationData,
      rendererSettings: {
        preserveAspectRatio: 'xMidYMid meet'
      }
    });
  }, []);
  
  return(
    <div id="signup-animation"></div>
  )
}

export default SignupAnimation;